// Root actions
import axios from 'axios'
import offline from '../offline/index'
import * as PusherPushNotifications from '@pusher/push-notifications-web'

const loginUrl = process.env.VUE_APP_API_URL + '/login'
const refreshUrl = process.env.VUE_APP_API_URL + '/refresh'

export default {
  increment({ commit }) {
    commit('INCREMENT')
  },

  setLoginLayout({ dispatch }) {
    dispatch('setLayout', 'login-layout')
  },

  setMainLayout({ dispatch }) {
    dispatch('setLayout', 'app-layout')
  },

  setLayout({ commit }, layout) {
    commit('SET_LAYOUT', layout)
  },

  // Set flag in state
  setIsLoggedFlag({ commit }, value) {
    commit('SET_IS_LOGGED_FLAG', value)
  },

  populateAuthState({ commit }) {
    commit('POPULATE_AUTH_AT_STATE')
  },

  // Request initial state
  initialState(context, payload) {
    offline.initialState()
  },

  // Apply initial state for store
  applyInitialState(context, payload) {
    console.log('apply initial state for root store')
  },

  setUser({ commit }, value) {
    commit('SET_USER', value)
  },

  fetchUser({ commit }) {
    return axios.get(process.env.VUE_APP_API_URL + '/me').then(response => {
      commit('SET_USER', response.data.data)
    })
  },

  login({ commit }, payload) {
    return axios
      .post(process.env.VUE_APP_API_URL + '/login', payload.data)
      .then(response => {
        commit('LOGIN', response.data)
        commit('SET_IS_LOGGED_FLAG', 1)
        commit('SET_USER', response.data.user)
        commit('POPULATE_AUTH_AT_STATE')
        return response
      })
  },
  reset({ commit }, payload) {
    return axios
      .post(process.env.VUE_APP_API_URL + '/password/reset', payload.data)
      .then(response => {
        return response.data
      })
  },
  forgotPassword({ commit }, payload) {
    return axios
      .post(process.env.VUE_APP_API_URL + '/password/email', payload.data)
      .then(response => {
        return response.data
      })
  },
  logout({ commit }) {
    window.beamsClient.stop().catch(console.error)
    window.beamsClient.clearAllState()
    commit('LOGOUT')
    commit('SET_IS_LOGGED_FLAG', 0)
    commit('POPULATE_AUTH_AT_STATE')
    commit('calls/RESET_STORE', null, { root: true })
    commit('root/RESET_STORE', null, { root: true })
  },

  // Attach auth header to axios
  attachAuthHeader({ getters }) {
    axios.interceptors.request.use(
      function(config) {
        const accessToken = getters.getAccessToken
        if (accessToken && config.url !== refreshUrl) {
          config.headers['Authorization'] = 'Bearer ' + accessToken
        }
        return config
      },
      function(error) {
        return Promise.reject(error)
      }
    )
  },

  // Call refresh
  refreshRequest({ getters }) {
    return axios.post(refreshUrl, { refresh_token: getters.getRefreshToken })
  },

  // Reset access object for future uses
  resetAccessRequest({ commit }) {
    return commit('REFRESH_REQUEST', null)
  },

  refreshAccessToken({ state, commit, dispatch }) {
    if (!state.refreshRequest) {
      // Only once call refresh
      commit('REFRESH_REQUEST', dispatch('refreshRequest'))
      return state.refreshRequest.then(response => {
        dispatch('resetAccessRequest')
        return response
      })
    }
    return state.refreshRequest
  },

  // Attach refreshing token functionality
  attachAuthRefresh({ dispatch, commit }, opts) {
    // const axios = opts.axios || axios

    axios.interceptors.response.use(
      function(response) {
        return response
      },
      function(error) {
        if (error.response !== undefined && error.response.status === 401) {
          const originalRequest = error.config

          if (originalRequest.url === loginUrl) {
            // It's error on login PAGE!
            return Promise.reject(error)
          } else if (originalRequest.url !== refreshUrl) {
            // Check if it's retried request
            if (error.config && !error.config._isRetry && 1) {
              return dispatch('refreshAccessToken')
                .then(response => {
                  // Mark as a retry request to call once
                  error.config._isRetry = true
                  // Remember new access token and populate store
                  commit('LOGIN', response.data)
                  commit('POPULATE_AUTH_AT_STATE')
                  // Add refreshed access token to retried request
                  error.config.headers['Authorization'] =
                    'Bearer ' + response.data.access_token
                  // Retry request
                  return axios(error.config)
                })
                .catch(() => {
                  dispatch('logout')
                  dispatch('setLoginLayout')
                  // Reject unauthorized requests
                  return Promise.reject(error)
                })
            }
            // Reject unauthorized requests
            return Promise.reject(error)
          }
        }
        // Reject all requests with not auth status
        return Promise.reject(error)
      }
    )
  },

  oneOfflineRequest({ dispatch, commit }, r) {
    console.log('******************* oneOfflineRequest ', r)
    let data = null
    if (r.type === 'video') {
      data = new FormData()
      const file = r.data.media.file
      data.append('file', file, 'file')
      data.append('type', 'video')
      data.append('name', file.name)
      /* delete r.data.media
      _.each(r.data, (element, index, list) => {
        data.append(index, element)
      })*/
    } else {
      data = r.data
    }
    data.offline = true
    return axios({
      method: r.method,
      url: r.url,
      data: data,
      headers: {},
      timeout: 30000
    }).then(response => {
      return { response: response, request: r, data: data }
    })
  },

  offlineFallback({ dispatch, commit }, data) {
    const params = data
    // Normalize params for API
    params.object_id = data.objectId
    params.action = data.type
    return axios.post(process.env.VUE_APP_API_URL + '/offline/fallback', data)
  },

  registerForPushNotifications({ getters, commit }) {
    const accessToken = getters.getAccessToken
    const user = getters.user
    const beamsUser = getters.beamsUser
    if (accessToken && user && !beamsUser) {
      const beamsTokenProvider = new PusherPushNotifications.TokenProvider({
        url: process.env.VUE_APP_API_URL + '/pusher/beams-auth',
        headers: {
          Authorization: 'Bearer ' + accessToken
        }
      })
      window.beamsClient
        .start()
        .then(() => {
          window.beamsClient.setUserId(user.username, beamsTokenProvider)
          console.log('Register For Beams Notifications', user.username)
          commit('SET_BEAMS_USER', user.username)
        })
        .catch(console.error)
    }
  }
}
